<template>
  <div>
    <div v-html="sHtml" v-if="tagArr.length === 0"></div>
    <div v-html="sHtml" ref="html" v-show="false"></div>
    <div>
      <div v-for="(item, index) in dataSource" :key="index">
        <template v-if="item.type == 'voice'">
          <slot :item="item" name="voice"></slot>
        </template>
        <template v-if="item.type == 'video'">
          <slot :item="item" name="video"></slot>
        </template>
        <RichBox v-if="item.type == 'image'" v-bind="getCoverReason(item.content)">
          <img :src="item.content" style="max-width:200px" />
        </RichBox>
        <template v-if="item.type == 'file'">
          <slot :item="item" name="file"></slot>
        </template>
      </div>
    </div>
    <RichBox
      v-for="({ tag, content, reason, suggestion, result }, index) in tagArr"
      :key="index"
      :reason="reason"
      :tag="tag"
      :result="result"
      :suggestion="suggestion"
    >
      <h1 v-if="tag === 'h1'">{{ content }}</h1>
      <p v-else-if="tag === 'p'">{{ content }}</p>
      <p v-else-if="tag === 'a'">{{ content }}</p>
      <img v-else-if="tag === 'img'" :src="content" />
      <Audio v-else-if="tag === 'audio'" :url="content" :visible="false" />
      <video v-else-if="tag === 'video'" :src="content" controls />
    </RichBox>
  </div>
</template>

<script>
import Vue from 'vue'
import Audio from '../Audio'
import RichBox from './RichBox'
import {getResult} from '@/api/common.js'
export default {
  components: { RichBox, Audio },
  props: {
    html: {
      type: String,
      default: ''
    },
    xid: {
      type: String,
      required: true
    },
    dataSource: {
      type: Object,
      required: true
    }
  },
  data() {
    return { sHtml: '', tagArr: [], reason: [] }
  },

  mounted() {
    this.render()
  },

  methods: {
    getCoverReason(content) {
      if (this.reason && this.reason.length > 0) {
        const reasonArr = this.reason.filter(item => item.content === content)
        const refuseArr = reasonArr.filter(item => item.suggestion === 0)
        const passArr = reasonArr.filter(item => item.suggestion === 1)
        const noArr = reasonArr.filter(item => item.suggestion !== 1 && item.suggestion !== 0)
        if (refuseArr.length > 0) {
          const reason = refuseArr.map(item => JSON.parse(item.result).label).join('、')
          return { reason, suggestion: 0 }
        } else if (passArr.length > 0) {
          return { reason: '', suggestion: 1 }
        } else {
          return { reason: '' }
        }
      }
      return { reason: '' }
    },
    getResult() {
      const [auditId, uninoId] = this.xid.split(',')
      return getResult({ auditId, uninoId } )
    },
    async render() {
      const { code, result } = await this.getResult()
      if (code === 1) {
        this.reason = result || []
      }
      const arr = []
      for (const item in this.dataSource) {
        arr.push(this.dataSource[item])
      }
      const htmlArr = arr.filter(item => item.type === 'text' || item.type === 'richtext')
      const renderHtml = html => {
        return new Promise(resolve => {
          if (html) {
            this.sHtml = html.content
              .replaceAll('<p></p>', '')
              .replaceAll('<p><', '<')
              .replaceAll('></p>', '>')
            if (!this.sHtml) {
              return
            }
            this.$nextTick(() => {
              // const audios = this.$refs['html'].getElementsByTagName('audio')
              const temp = this.$refs.html
              const tagArr = temp.children
              // if (tagArr.length === 0) {
              // }
              for (const item of tagArr) {
                if (item instanceof HTMLHeadingElement) {
                  const content = item.innerText
                  if (!content.trim()) continue
                  const reasonArr = this.reason.filter(item => content.indexOf(item.content) > -1)
                  const refuseArr = reasonArr.filter(item => item.suggestion === 0)
                  const passArr = reasonArr.filter(item => item.suggestion === 1)
                  const noArr = reasonArr.filter(item => item.suggestion !== 1 && item.suggestion !== 0)
                  if (refuseArr.length > 0) {
                    const reason = refuseArr
                      .map(item =>
                        JSON.parse(item.result)
                          .details.map(item => item.label)
                          .join('、')
                      )
                      .join('、')
                    this.tagArr.push({ tag: 'h1', content, reason, suggestion: 0 })
                  } else if (passArr.length > 0) {
                    this.tagArr.push({ tag: 'h1', content, reason: '', suggestion: 1 })
                  } else {
                    this.tagArr.push({ tag: 'h1', content, reason: '' })
                  }
                } else if (item instanceof HTMLImageElement) {
                  const content = item.src
                  if (!content.trim()) continue
                  const reasonArr = this.reason.filter(item => item.content === content)
                  const refuseArr = reasonArr.filter(item => item.suggestion === 0)
                  const passArr = reasonArr.filter(item => item.suggestion === 1)
                  const noArr = reasonArr.filter(item => item.suggestion !== 1 && item.suggestion !== 0)
                  if (refuseArr.length > 0) {
                    const reason = refuseArr.map(item => JSON.parse(item.result).label).join('、')
                    this.tagArr.push({ tag: 'img', content, reason, suggestion: 0 })
                  } else if (passArr.length > 0) {
                    this.tagArr.push({ tag: 'img', content, reason: '', suggestion: 1 })
                  } else {
                    this.tagArr.push({ tag: 'img', content, reason: '' })
                  }
                } else if (item instanceof HTMLAudioElement) {
                  const content = item.src
                  if (!content.trim()) continue
                  const reasonArr = this.reason.filter(item => item.content === content)
                  const refuseArr = reasonArr.filter(item => item.suggestion === 0)
                  const passArr = reasonArr.filter(item => item.suggestion === 1)
                  const noArr = reasonArr.filter(item => item.suggestion !== 1 && item.suggestion !== 0)
                  if (refuseArr.length > 0) {
                    const reason = refuseArr.map(item => JSON.parse(item.result).label).join('、')
                    this.tagArr.push({ tag: 'audio', content, reason, suggestion: 0, result: refuseArr[0].result })
                  } else if (passArr.length > 0) {
                    this.tagArr.push({ tag: 'audio', content, reason: '', suggestion: 1 })
                  } else {
                    this.tagArr.push({ tag: 'audio', content, reason: '' })
                  }
                } else if (item instanceof HTMLVideoElement) {
                  const content = item.src
                  if (!content.trim()) continue
                  this.tagArr.push({ tag: 'video', content, reason: '' })
                } else if (item instanceof HTMLParagraphElement) {
                  const content = item.innerText
                  if (!content.trim()) continue
                  const reasonArr = this.reason.filter(item => content.indexOf(item.content) > -1)
                  const refuseArr = reasonArr.filter(item => item.suggestion === 0)
                  const passArr = reasonArr.filter(item => item.suggestion === 1)
                  const noArr = reasonArr.filter(item => item.suggestion !== 1 && item.suggestion !== 0)
                  if (refuseArr.length > 0) {
                    const reason = refuseArr
                      .map(item =>
                        JSON.parse(item.result)
                          .details.map(item => item.label)
                          .join('、')
                      )
                      .join('、')
                    this.tagArr.push({ tag: 'p', content, reason, suggestion: 0 })
                  } else if (passArr.length > 0) {
                    this.tagArr.push({ tag: 'p', content, reason: '', suggestion: 1 })
                  } else {
                    this.tagArr.push({ tag: 'p', content, reason: '' })
                  }
                } else if (item instanceof HTMLAnchorElement) {
                  const content = item.innerText
                  if (!content.trim()) continue
                  const reasonArr = this.reason.filter(item => content.indexOf(item.content) > -1)
                  const refuseArr = reasonArr.filter(item => item.suggestion === 0)
                  const passArr = reasonArr.filter(item => item.suggestion === 1)
                  const noArr = reasonArr.filter(item => item.suggestion !== 1 && item.suggestion !== 0)
                  if (refuseArr.length > 0) {
                    const reason = refuseArr
                      .map(item =>
                        JSON.parse(item.result)
                          .details.map(item => item.label)
                          .join('、')
                      )
                      .join('、')
                    this.tagArr.push({ tag: 'a', content, reason, suggestion: 0 })
                  } else if (passArr.length > 0) {
                    this.tagArr.push({ tag: 'a', content, reason: '', suggestion: 1 })
                  } else {
                    this.tagArr.push({ tag: 'a', content, reason: '' })
                  }
                }
              }

              for (let i = tagArr.length - 1; i >= 0; i--) {
                const ele = tagArr[i]
                if (!(ele instanceof HTMLBRElement)) {
                  temp.removeChild(ele)
                }
              }
              const contentStr = temp.innerHTML
              const contentArr = contentStr
                .split('<br/>')
                .map(item => item.split('<br>'))
                .reduce((a, b) => {
                  const arr = []
                  if (a.length) {
                    arr.push.apply(arr, a)
                  } else {
                    arr.push.call(arr, a)
                  }
                  if (b.length) {
                    arr.push.apply(arr, b)
                  } else {
                    arr.push.call(arr, b)
                  }
                  return arr
                }, '')
              for (const content of contentArr) {
                if (!content.trim()) continue
                const reasonArr = this.reason.filter(item => content.indexOf(item.content) > -1)
                const refuseArr = reasonArr.filter(item => item.suggestion === 0)
                const passArr = reasonArr.filter(item => item.suggestion === 1)
                const noArr = reasonArr.filter(item => item.suggestion !== 1 && item.suggestion !== 0)
                if (refuseArr.length > 0) {
                  const reason = refuseArr
                    .map(item =>
                      JSON.parse(item.result)
                        .details.map(item => item.label)
                        .join('、')
                    )
                    .join('、')
                  this.tagArr.push({ tag: 'p', content, reason, suggestion: 0 })
                } else if (passArr.length > 0) {
                  this.tagArr.push({ tag: 'p', content, reason: '', suggestion: 1 })
                } else {
                  this.tagArr.push({ tag: 'p', content, reason: '' })
                }
              }
              resolve()
            })
          }
        })
      }
      for (const html of htmlArr) {
        await renderHtml(html)
      }

      // for (let i = 0, length = audios.length; i < length; i++) {
      //   new Vue({
      //     el: audios[i],
      //     template: '<Audio :url="url" :aliyunAudit="2" :visible="true" :xid="xid"/>',
      //     components: { Audio },
      //     data: { url: audios[i].src, xid: this.xid }
      //   })
      // }
    }
  }
}
</script>

<style scoped>
img {
  max-width: 100%;
  object-fit: scale-down;
}
video {
  max-width: 100%;
}
</style>
